import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

enum CrashlyticsLogMessage {
  PageView = 'Page',
}

const pageView = (pathname: string): Promise<void> =>
  FirebaseCrashlytics.log({ message: `${CrashlyticsLogMessage.PageView}: ${pathname}` });

export const crashlyticsEvents = {
  pageView,
};
